import validate from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/node_modules/nuxt/dist/pages/runtime/validate.js";
import application_45global from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/middleware/application.global.ts";
import manifest_45route_45rule from "/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  application_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "app-middleware": () => import("/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/app/middleware/appMiddleware.js")
}